import type {
  ArbitralAlertaItem,
  ArbitralAlertasAtivosPagina,
} from '@/features/secretaria-arbitral/types';

/**
 * Lê a resposta de `GET /admin/arbitral/alertas`. O core anterior à paginação devolve a lista
 * inteira (array) e ignora `processoIds`; o front sobe antes do back, e nessa janela a lista vira
 * uma página única.
 *
 * TODO: remover o caminho do array depois do deploy do core#2155.
 *
 * @example paginaDeAlertasAtivos(body.data).totalGeral
 */
export function paginaDeAlertasAtivos(payload: unknown): ArbitralAlertasAtivosPagina {
  if (Array.isArray(payload)) {
    const items = payload as ArbitralAlertaItem[];
    return { items, total: items.length, totalGeral: items.length, page: 1, limit: items.length };
  }
  const pagina = (payload ?? {}) as Partial<ArbitralAlertasAtivosPagina>;
  const items = pagina.items ?? [];
  const total = pagina.total ?? items.length;
  return {
    items,
    total,
    totalGeral: pagina.totalGeral ?? total,
    page: pagina.page ?? 1,
    limit: pagina.limit ?? items.length,
  };
}
